import React, { useState, useEffect } from "react";

import useTable from "../useTable";
import ModalActualizarUsuario from "./modalActualizarUsuario";
import axios from "axios";

import { CambiarClave } from "./modalCambiarClave";
import { Mensaje } from "../mensajes";
/* import { ToastsGeneral } from '../toasts'; */
import { Toasts } from "../toasts";
import { Dimmer } from "../spinner";

const headCells = [
  {
    id: "1",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ID USUARIO",
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "USUARIO",
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "NOMBRES",
    textAlign: "center",
  },
  {
    id: "opciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: " OPCIONES",
    textAlign: "center",
  },
];

function TablaUsuarios() {
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [titulo1, setTitulo1] = useState();
  const [msg1, setMsg1] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [idUsuarioH, setIdUsuarioH] = useState(0);
  const [contarRet, setContarRet] = useState(0);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [usuarioH, setUsuarioH] = useState();
  const [persona, setPersona] = useState();
  const [organizacion, setOrganizacion] = useState();
  const [configCome, setConfigCome] = useState();
  const [usuariow, setUsuariow] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [pagow, setPagow] = useState();
  const [retencion, setRetencion] = useState();
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [anioActu, setAnioActu] = useState(localStorage.getItem("anioactu"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const permiso =
    JSON.parse(localStorage.getItem("accusuario")) === null
      ? "0000"
      : JSON.parse(localStorage.getItem("accusuario"));

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  /*   const accusertim = JSON.parse(localStorage.getItem('accusertim')); */

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setIdUsuario(obj.idusuario);
    setEspiritu(obj.espiritu);
    seleccionarUsuarios();
  }, []);

  const seleccionarUsuarios = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/comun/getallusuarios`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            console.log(response.data);
            setRecords(response.data);
            setActivate(false);
          } else {
            setRecords([]);
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectUsuario = (idusuario) => {
    let endpoint = `${op.conexion}/api/comun/selectusuario?idusuario=${idusuario}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idusuario > 0) {
            console.log(response.data);
            setPersona({
              cedula: response.data.cedula,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              correoe: response.data.correoe,
              tlf1: response.data.tlf1,
              tlf2: response.data.tlf2,
              fnacimiento: response.data.fnacimiento,
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
              direccion: response.data.direccionp,
            });
            setUsuarioH(response.data);
            setMostrar(true);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Error al cargar el usuario",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const gestionarUsuarios = (id, op, per) => (e) => {
    e.preventDefault();

    if (per.toString() === "1") {
      setOperacion(op);

      if (op === 4) {
        /* if(accusertim.substring(0,1) !== '0'){ */
        setDeshabilitado(true);

        setIdUsuarioH(id);
        setActivate(true);
        SelectUsuario(id);
        /*   }  else {
            setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
          }
            */
      } else if (op === 1) {
        /*   if(accusertim.substring(1,2) !== '0'){ */

        setUsuarioH();
        setUsuariow();
        setPersona();
        setDeshabilitado(false);
        setMostrar(true);
        /*   } else {
              setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
            }
     */
      } else if (op === 2) {
        /*    if(accusertim.substring(2,3) !== '0'){ */
        setDeshabilitado(false);

        setIdUsuarioH(id);
        setActivate(true);
        SelectUsuario(id);
        /*        } else{
              setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
            
            } */
      } else if (op === 3) {
        /*  if(accusertim.substring(3,4) !== '0'){ */
        if (idUsuario === id) {
          setMensaje({
            mostrar: true,
            titulo: "Notificacion",
            texto: "El Usuario no se puede eliminar porque esta logueado",
            icono: "informacion",
          });
          return;
        }
        setDeshabilitado(true);

        setIdUsuarioH(id);
        setActivate(true);
        SelectUsuario(id);

        /*   } else{
               setToast({... toast ,mostrar:true, titulo:'Notificación', mensaje:'No Posee los Permisos para Realizar esta Acción'})
            } */
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
              ? "No posee permiso para Editar"
              : op === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  const cerrarModalActualizar = () => {
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar(false);
    setActivate(false);
  };

  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar(false);
      return;
    }
    if (operacion === 1) {
      setIdUsuarioH(0);
    }
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar(false);
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };

  return (
    <div className="h-100 w-100 p-0 m-0">
      <div className="container">
        <div className="content">
          <div className="card px-3 py-2">
            <div className="col-md-12 row m-0 py-1">
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control search-input form-control-sm rounded-pill"
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
              </div>

              <div className="col-md-3 ml-auto">
                <button
                  disabled={
                    permiso &&
                    permiso.substring(1, 2) !== "1" &&
                    permiso.substring(2, 3) !== "1"
                  }
                  onClick={cambiarClave}
                  style={{ marginBottom: "10px" }}
                  className={
                    permiso.toString().substring(1, 2) === "1"
                      ? "btn btn-sm btn-primary rounded-pill"
                      : "btn btn-sm btn-secondary rounded-pill"
                  }
                >
                  <i className="fas fa-key"> Cambiar Clave</i>{" "}
                </button>
              </div>
              <div className="col-md-1 ml-auto">
                <button
                  onClick={gestionarUsuarios(
                    "",
                    1,
                    permiso.toString().substring(1, 2),
                  )}
                  style={{ marginBottom: "5px" }}
                  className={
                    permiso.toString().substring(1, 2) === "1"
                      ? "btn btn-sm btn-primary rounded-pill"
                      : "btn btn-sm btn-secondary rounded-pill"
                  }
                >
                  <i className="fas fa-plus"></i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }}>
              <TblContainer>
                <TblHead />

                <tbody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <tr key={index} style={{ padding: "0" }}>
                        <td
                          className="align-baseline"
                          style={{ textAlign: "center", width: "50px" }}
                        >
                          {item.idusuario}
                        </td>
                        <td
                          className="align-baseline"
                          style={{ textAlign: "center", width: "250px" }}
                        >
                          {item.login}
                        </td>
                        <td
                          className="align-baseline"
                          style={{ textAlign: "start", width: "250px" }}
                        >
                          {item.nombres + " " + item.apellidos}
                        </td>
                        <td
                          className="align-baseline"
                          style={{ textAlign: "center", width: "90px" }}
                        >
                          <button
                            onClick={gestionarUsuarios(
                              item.idusuario,
                              4,
                              permiso.toString().substring(0, 1),
                            )}
                            className={
                              permiso.toString().substring(0, 1) === "1"
                                ? "btn btn-sm btn-info rounded-circle"
                                : "btn btn-sm btn-secondary rounded-circle"
                            }
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarUsuarios(
                              item.idusuario,
                              2,
                              permiso.toString().substring(2, 3),
                            )}
                            className={
                              permiso.toString().substring(2, 3) === "1"
                                ? "btn btn-sm btn-warning rounded-circle"
                                : "btn btn-sm btn-secondary rounded-circle"
                            }
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarUsuarios(
                              item.idusuario,
                              3,
                              permiso.toString().substring(3, 4),
                            )}
                            className={
                              permiso.toString().substring(3, 4) === "1"
                                ? "btn btn-sm btn-danger rounded-circle"
                                : "btn btn-sm btn-secondary rounded-circle"
                            }
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <ModalActualizarUsuario
        show={mostrar}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        usuario={usuarioH}
        datospersonales={persona}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        onHideRender={seleccionarUsuarios}
      />

      <CambiarClave show={mostrar2} onHide={handleCloseClave} />

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}

export default TablaUsuarios;
